import { Box } from "@mui/material";
import { dateTimeFormatter } from "src/utils/date";
import { GridColDef } from "@mui/x-data-grid-premium";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import ByzDataGridToolbar from "src/components/core-components/mui/data-grid/toolbar";
import { useTranslate } from "src/locales";
import type { AllRequestRow } from "../types";
import { REQUEST_LIST_GRID_COMPACT_SX } from "../constants";

interface AllArrivalsGridProps {
  rows: AllRequestRow[];
  loading?: boolean;
  onRowSelect?: (row: AllRequestRow) => void;
}

export default function AllArrivalsGrid({
  rows,
  loading = false,
  onRowSelect,
}: AllArrivalsGridProps) {
  const { t } = useTranslate();

  const columns: GridColDef<AllRequestRow>[] = [
    {
      field: "performedBy",
      headerName: t("request-list.columns.performed-by", "default", { defaultValue: "İşlem Yapan" }),
      flex: 1,
      minWidth: 140,
    },
    {
      field: "actionDate",
      headerName: t("request-list.columns.action-date", "default", { defaultValue: "İşlem Tarihi" }),
      width: 170,
      valueFormatter: (value) => dateTimeFormatter(value, "dd.MM.yyyy HH:mm:ss"),
    },
    {
      field: "serviceType",
      headerName: t("request-list.columns.request-type", "default", { defaultValue: "İstek Türü" }),
      flex: 1,
      minWidth: 130,
    },
    {
      field: "departmentName",
      headerName: t("request-list.columns.department-name", "default", { defaultValue: "Bölüm Adı" }),
      flex: 1,
      minWidth: 140,
    },
    {
      field: "doctorName",
      headerName: t("request-list.columns.doctor-name", "default", { defaultValue: "Doktor Adı" }),
      flex: 1,
      minWidth: 140,
    },
    {
      field: "requestStatus",
      headerName: t("request-list.columns.status", "default", { defaultValue: "Durumu" }),
      width: 120,
    },
    {
      field: "requestDate",
      headerName: t("request-list.columns.request-date", "default", { defaultValue: "İstek Tarihi" }),
      width: 170,
      valueFormatter: (value) => dateTimeFormatter(value, "dd.MM.yyyy HH:mm:ss"),
    },
  ];

  return (
    <Box sx={{ width: "100%", flex: 1, minHeight: 400 }}>
      <ByzMuiDataGrid
        rows={rows}
        columns={columns}
        checkboxSelection
        disableRowSelectionOnClick
        pagination
        pageSizeOptions={[10]}
        initialState={{ 
          density: "compact",
          pagination: { paginationModel: { pageSize: 10 } }
        }}
        loading={loading}
        customToolbar={() => (
          <ByzDataGridToolbar
            searchPlaceholder={t("request-list.search", "default", { defaultValue: "Ara..." })}
            searchIconColor="#1E88E5"
          />
        )}
        whiteGrid
        headerWhite
        getRowId={(row) => row.id}
        onRowClick={(params) => onRowSelect?.(params.row)}
        sx={{
          ...REQUEST_LIST_GRID_COMPACT_SX,
          "& .MuiDataGrid-row": {
            cursor: onRowSelect ? "pointer" : "default",
          },
        }}
      />
    </Box>
  );
}
